/* Site header: Read ▾ / Learn ▾ / Tom ▾ (and the phone ☰) toggle one index-card panel; the heading that opened it
   lights its own column. Escape or a click outside closes it. A click on a panel link does NOT snap the panel shut:
   the item shows a "going" state and the panel stays until the new page paints, so the click feels answered.
   Opening the panel also prefetches its pages (Speculation Rules, immediate) so the hop is near-instant. */
(function () {
  var nav = document.querySelector('[data-twb-nav]');
  if (!nav) return;
  var panel = nav.querySelector('#twb-menu-panel');
  var heads = Array.prototype.slice.call(nav.querySelectorAll('[data-twb-menu]'));
  var cols = Array.prototype.slice.call(nav.querySelectorAll('[data-twb-col]'));
  if (!panel || !heads.length) return;
  var current = '';
  var prefetched = false;
  function prefetchPanel() {
    if (prefetched) return;
    prefetched = true;
    try {
      if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
      var conn = navigator.connection || {};
      if (conn.saveData || /(^|[^3-9])2g/.test(conn.effectiveType || '')) return;
      var urls = [];
      Array.prototype.forEach.call(panel.querySelectorAll('a.twb-menu-item[href]'), function (a) {
        if (a.origin !== location.origin) return;
        if (/^\/(a|cart|checkout|account|admin|password)\b/.test(a.pathname)) return;
        var u = a.pathname + a.search;
        if (u === location.pathname + location.search) return;
        if (urls.indexOf(u) === -1) urls.push(u);
      });
      if (!urls.length) return;
      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: urls, eagerness: 'immediate' }] });
      document.head.appendChild(s);
    } catch (e) { /* prefetch is a nicety */ }
  }
  function setOpen(key) {
    current = key || '';
    var open = !!current;
    panel.hidden = !open;
    nav.classList.toggle('twb-nav-open', open);
    heads.forEach(function (h) { h.setAttribute('aria-expanded', open && h.getAttribute('data-twb-menu') === current ? 'true' : 'false'); });
    cols.forEach(function (c) { c.classList.toggle('twb-menu-col-on', open && c.getAttribute('data-twb-col') === current); });
    if (open) prefetchPanel();
  }
  heads.forEach(function (h) {
    h.addEventListener('click', function () {
      var key = h.getAttribute('data-twb-menu') || 'all';
      setOpen(!panel.hidden && current === key ? '' : key);
    });
  });
  panel.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.twb-menu-item') : null;
    if (!a) return;
    var samePage = a.pathname === location.pathname && a.hash;
    if (samePage) { setOpen(''); return; }            /* #free / #join on the home page: close and let it scroll */
    Array.prototype.forEach.call(panel.querySelectorAll('.twb-menu-item-going'), function (x) { x.classList.remove('twb-menu-item-going'); });
    a.classList.add('twb-menu-item-going');            /* stays lit until the next page paints */
  });
  window.addEventListener('pageshow', function () {    /* back/forward cache: never come back to a stuck "going" item */
    Array.prototype.forEach.call(panel.querySelectorAll('.twb-menu-item-going'), function (x) { x.classList.remove('twb-menu-item-going'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { var k = current; setOpen(''); var h = heads.filter(function (x) { return x.getAttribute('data-twb-menu') === k; })[0]; if (h) h.focus(); } });
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    var t = e.target;
    if (t && t.closest && t.closest('[data-twb-nav]')) return;
    setOpen('');
  });
})();
